export default __webpack_public_path__ + "static/media/Banner_docthank.b84eb960.png";